import React from "react";
import LegalPageLayout from "../components/subComponents/LegalPageLayout";

function PrivacyPolicy() {
	return (
		<LegalPageLayout title="Privacy Policy" lastUpdated="September 2026">
			<p className="legalIntro">
				This page explains what information the GCAS Regina website
				collects and how it's used. GCAS Regina is a volunteer-run,
				nonprofit community organization, and this site exists to share
				information, not to track visitors. If anything here is unclear,
				contact us directly at{" "}
				<a href="mailto:info.gcasregina@gmail.com">
					info.gcasregina@gmail.com
				</a>
				.
			</p>

			<section className="legalSection">
				<h2 className="legalSectionHeading">Information we collect</h2>
				<p>
					The only personal information this site collects is what you
					choose to submit through the contact form: your first name, last
					name, email address, and message. We use it solely to respond to
					your inquiry.
				</p>
				<p>
					This site doesn't require an account, doesn't process payments,
					and doesn't run its own analytics or advertising cookies.
				</p>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">Third-party services we use</h2>
				<ul className="legalList">
					<li>
						Contact form submissions are processed by Formspree, a
						third-party form service. Their handling of that data is
						governed by Formspree's own privacy policy.
					</li>
					<li>
						Event content, such as photos, dates, and descriptions, is
						managed through Sanity, a content platform. This is public
						event information, not personal data collected about
						visitors.
					</li>
					<li>
						Fonts, icons, and animations are loaded from Google Fonts,
						Font Awesome, and dotlottie.host. Loading these resources may
						expose your IP address to those providers, as with any
						website that uses them, under their own respective policies.
					</li>
					<li>
						Joining our WhatsApp community happens entirely within
						WhatsApp and is governed by WhatsApp's own privacy policy,
						not this one.
					</li>
				</ul>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">What we don't do</h2>
				<p>
					We don't sell, rent, or trade your information, and we don't use
					a contact form submission for anything beyond replying to you.
				</p>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">Children's privacy</h2>
				<p>
					This site is intended for a general community audience and is
					not directed at children.
				</p>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">Changes to this policy</h2>
				<p>
					We may update this page from time to time as the site changes.
					The date above reflects the most recent update.
				</p>
			</section>

			<section className="legalSection">
				<h2 className="legalSectionHeading">Contact us</h2>
				<p>
					Questions about this policy? Email{" "}
					<a href="mailto:info.gcasregina@gmail.com">
						info.gcasregina@gmail.com
					</a>
					.
				</p>
			</section>
		</LegalPageLayout>
	);
}

export default PrivacyPolicy;
